import { CartLinesUpdateEvent } from '@shopify/events';
class SanjarClearCart extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.querySelector('button')?.addEventListener('click', () => this.clear(), { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  async clear() {
    if (this.pending) return;
    this.pending = true;
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    button.disabled = true;
    button.textContent = 'Removing…';
    const deferred = CartLinesUpdateEvent.createPromise();
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e => e.dataset.sectionId))].slice(0, 5);
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'remove', context: 'cart', lines: [], promise: deferred.promise }));
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sections: sections.join(','), sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error('Unable to empty the cart. Please try again.');
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: cart.sections } });
      if (sections.some(id => !cart.sections?.[id])) window.location.reload();
    } catch (error) {
      deferred.resolve({ detail: { didError: true } });
      if (status) status.textContent = 'Unable to empty the cart. Please try again.';
    } finally {
      this.pending = false;
      button.disabled = false;
      button.textContent = 'Remove all';
    }
  }
}
if (!customElements.get('sl-clear-cart')) customElements.define('sl-clear-cart', SanjarClearCart);
